import React from "react";
import * as RBS from "react-bootstrap";
import { Link } from "react-router-dom";
import instagramLogo from "./instagram-brands.svg";
import classes from "./Navbar.module.css";
import "./navbar.css";
import logo from "./Assets/logo3.png";

const NavBar = () => {
  return (
    <div className="App">
      <div>
        <div className={classes.location}>
          <div>
            {" "}
            <span className="separator">
              17817 Leslie Street Unit 30 Newmarket ON L3Y 8C6, Canada
            </span>{" "}
            <span className="phonenumber">
              <a href="tel:905-836-9505">905-836-9505</a>
            </span>
          </div>
        </div>
        <RBS.Navbar
          collapseOnSelect
          expand="lg"
          className={classes.navbar}
          variant="dark"
        >
          <div className={classes.hamburger}>
            <RBS.Navbar.Toggle aria-controls="responsive-navbar-nav" />
          </div>
          <RBS.Navbar.Collapse
            id="responsive-navbar-nav"
            className={classes.navbarChoice}
          >
            <RBS.Nav className="m-auto">
              <Link class="st1" style={{ textDecoration: "none" }} to="/">
                <RBS.Nav.Link href="#about">HOME</RBS.Nav.Link>
              </Link>
              <div className="st1">
                <RBS.NavDropdown
                  menuVariant="dark"
                  title="ABOUT US"
                  id="collasible-nav-dropdown"
                >
                  <Link style={{ textDecoration: "none" }} to="/DrMackensie">
                    <RBS.NavDropdown.Item
                      className={classes.navback}
                      href="#action/4.1"
                    >
                      Dr Mackensie Jordan DC
                    </RBS.NavDropdown.Item>
                  </Link>
                  <Link style={{ textDecoration: "none" }} to="/AthwalRMT">
                    <RBS.NavDropdown.Item
                      className={classes.navback}
                      href="#action/4.2"
                    >
                      Puneet Athwal RMT 
                    </RBS.NavDropdown.Item>
                  </Link>
                  <Link style={{ textDecoration: "none" }} to="/DrEmma">
                    <RBS.NavDropdown.Item
                        className={classes.navback}
                        href="#action/4.3"
                    >
                      Dr Emma Whelpton DC
                    </RBS.NavDropdown.Item>
                  </Link>
                  <Link style={{ textDecoration: "none" }} to="/ForumPT">
                    <RBS.NavDropdown.Item
                        className={classes.navback}
                        href="#action/4.4"
                    >
                      Forum Gandhi PT
                    </RBS.NavDropdown.Item>
                  </Link>
                </RBS.NavDropdown>
              </div>
              <div className="st1">
                <RBS.NavDropdown title="SERVICES" id="collasible-nav-dropdown">
                  <Link style={{ textDecoration: "none" }} to="/Chiropractic">
                    <RBS.NavDropdown.Item href="#action/3.1">
                      Chiropractic
                    </RBS.NavDropdown.Item>
                  </Link>
                  <Link style={{ textDecoration: "none" }} to="/FST">
                    <RBS.NavDropdown.Item href="#action/3.2">
                      Fascial Stretch Therapy
                    </RBS.NavDropdown.Item>
                  </Link>
                  <Link style={{ textDecoration: "none" }} to="/Acupuncture">
                    <RBS.NavDropdown.Item href="#action/3.4">
                      Functional Integrated Acupuncture
                    </RBS.NavDropdown.Item>
                  </Link>
                  <Link style={{ textDecoration: "none" }} to="/Orthotics">
                    <RBS.NavDropdown.Item href="#action/3.5">
                      Orthotics
                    </RBS.NavDropdown.Item>
                  </Link>
                  <Link style={{ textDecoration: "none" }} to="/Pelvic">
                    <RBS.NavDropdown.Item href="#action/3.6">
                      Pelvic Floor
                    </RBS.NavDropdown.Item>
                  </Link>
                </RBS.NavDropdown>
              </div>

              <Link class="st1" style={{ textDecoration: "none" }} to="Fees">
                <RBS.Nav.Link href="#fees">FEES</RBS.Nav.Link>
              </Link>
              <a href="https://www.instagram.com/amplifynewmarket/">
                <img className={classes.icon} src={instagramLogo} alt="" />
              </a>
            </RBS.Nav>
          </RBS.Navbar.Collapse>
        </RBS.Navbar>
      </div>
      {/**
       * Logo box
       */}
      <div className={classes.box}>
        <img className={classes.logo} src={logo} alt="logo" />
      </div>
    </div>
  );
};

export default NavBar;
